<template>
  <v-row>
    <v-expansion-panels
      :accordion="accordionsPanel.accordion"
      :popout="accordionsPanel.popout"
      :inset="accordionsPanel.inset"
      :multiple="accordionsPanel.multiple"
      :focusable="accordionsPanel.focusable"
      :disabled="accordionsPanel.disabled"
      :readonly="accordionsPanel.readonly"
      :flat="accordionsPanel.flat"
      :hover="accordionsPanel.hover"
      :tile="accordionsPanel.tile"
    >
      <v-expansion-panel>
        <v-expansion-panel-header
          ><span
            class="allergens-expansion-panel-header"
            :style="{ color: formLabelTheme }"
            >{{ title }}</span
          >
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-col cols="12" class="products-select py-0 py-sm-1">
            <div>
              <v-row justify="start">
                <v-col cols="12" sm="4" md="3">
                  <v-text-field
                    ref="searchInputValue"
                    :value="searchValue"
                    v-model="searchInputValue"
                    label="Buscar producto"
                    class="select-box"
                    outlined
                    dense
                    prepend-inner-icon="mdi-magnify"
                    @keyup="$emit('update:searchInput', searchInputValue)"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                    ref="categorySelectedValue"
                    outlined
                    dense
                    :value="categoryValue"
                    v-model="categorySelectedValue"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    label="Filtrar por categoría"
                    @change="
                      $emit('update:categorySelected', categorySelectedValue)
                    "
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                    ref="selectionSelectedValue"
                    outlined
                    dense
                    :value="selectionValue"
                    v-model="selectionSelectedValue"
                    :items="selection"
                    item-text="text"
                    item-value="value"
                    label="Filtrar por Selección"
                    @change="
                      $emit('update:selectionSelected', selectionSelectedValue)
                    "
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <v-data-table
              :headers="headers"
              :items="getCollections"
              class="elevation-1"
              :search="searchInput"
              :footer-props="{
                'items-per-page-options': [50, 100, 150, -1]
              }"
              :items-per-page="50"
              no-data-text="No se han encontrado resultados. Por favor, revisa los
              filtros de búsqueda!"
            >
              <template v-slot:[`item.category_id`]="{ item }">
                <div>
                  {{ getCategory(item.category_id, type) }}
                </div>
              </template>
              <template v-slot:[`item.active`]="{ item }">
                <div>
                  <v-switch
                    class="pt-5"
                    v-model="item.active"
                    @change="onChangeSelection(item)"
                  />
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>
<script>
export default {
  name: "menus-expansion-panels",
  props: [
    "accordionsPanel",
    "headers",
    "getCollections",
    "searchInput",
    "categories",
    "categorySelected",
    "selection",
    "selectionSelected",
    "title",
    "type"
  ],
  computed: {
    selectionValue() {
      return this.selectionSelected;
    },
    categoryValue() {
      return this.categorySelected;
    },
    searchValue() {
      return this.searchInput;
    }
  },
  mounted() {
    this.selectionSelectedValue = this.selectionSelected;
  },
  watch: {
    selectionValue(newVal) {
      this.selectionSelectedValue = newVal;
    },
    categoryValue(newVal) {
      this.categorySelectedValue = newVal;
    },
    searchValue(newVal) {
      this.searchInputValue = newVal;
    }
  },
  data() {
    return {
      categorySelectedValue: "",
      searchInputValue: "",
      selectionSelectedValue: "",
      validation: {
        name: [v => (!!v && !!v.trim()) || "Nombre es requerido"],
        price: [
          v =>
            (v !== undefined && parseFloat(v) > -1) ||
            "Por favor, introduce un Precio válido"
        ]
      }
    };
  },
  methods: {
    getCategory(id, type) {
      if (this.categories !== undefined && type === "Drink") {
        return this.getCategoryName(this.categories, id);
      } else if (this.categories !== undefined && type === "Food") {
        return this.getCategoryName(this.categories, id);
      } else if (this.categories !== undefined && type === "Dessert") {
        return this.getCategoryName(this.categories, id);
      }
    },
    onChangeSelection(product) {
      this.$emit("onChangeSelection", product);
    }
  }
};
</script>
<style scoped></style>
